<div class="login_container">
  <main>
    <div class="logo-content">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-12 col-md-auto text-center">
            <div class="logo mb-0">
            </div>
            <!-- end -->
            <h1 class="h6 text-uppercase fw-bold" style="color:#9a0014;">Backoffice Colonial Vital</h1>
            <h2>Accede con tus datos</h2>
            <!-- end -->
          </div>
        </div>
      </div>
    </div>
    <!-- logo -->
    <div class="login_content">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-9 col-md-7 col-lg-5">
            <div class="card-login">
              <figure class="">
                <img alt="" src="./assets/img/figure-login.png">
              </figure>
              <!-- end -->
              <div class="body-login">
                <!-- One flow for every role: who you are is resolved after sign-in -->
                <div class="content">
                  <div class="form-group">
                    <button (click)="login()"
                      class="mx-auto btn-primary btn btn-border-red bg-btn-red rounded-pill gap-2 fw-bold d-flex justify-content-center align-items-center py-2 px-3 px-md-4 mb-4"
                      style="width: fit-content;">
                      <span class="material-symbols-outlined">key</span>
                      Iniciar sesión
                    </button>
                  </div>
                </div>
                <div class="footer-content">
                  <p class="m-0">¿Aún no tienes una cuenta? <a href="javascript:void(0)"
                      (click)="register()">Regístrate</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- login -->
  </main>
</div>